import { render, staticRenderFns } from "./OrganizationalChartPage.vue?vue&type=template&id=2fede6f4&scoped=true&"
import script from "./OrganizationalChartPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationalChartPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationalChartPage.vue?vue&type=style&index=0&id=2fede6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fede6f4",
  null
  
)

export default component.exports